// extracted by mini-css-extract-plugin
var _1 = "generate-button--rvTvnF8";
var _2 = "generate-section--XVAL1Ks";
var _3 = "input--kc8XJkt";
export { _1 as "generateButton", _2 as "generateSection", _3 as "input" }
